import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  currentProjectId: null,
  currentProjectName: '',
  projects: [],
  loading: false,
  error: null,
};

const projectSlice = createSlice({
  name: 'project',
  initialState,
  reducers: {
    setCurrentProject: (state, action) => {
      state.currentProjectId = action.payload.id;
      state.currentProjectName = action.payload.project_name;
    },
    setProjects: (state, action) => {
      state.projects = action.payload;
    },
    addProject: (state, action) => {
      state.projects.push(action.payload);
    },
    removeProject: (state, action) => {
      state.projects = state.projects.filter(p => p.id !== action.payload);
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    clearCurrentProject: (state) => {
      state.currentProjectId = null;
      state.currentProjectName = '';
    },
  },
});

export const {
  setCurrentProject,
  setProjects,
  addProject,
  removeProject,
  setLoading,
  setError,
  clearCurrentProject,
} = projectSlice.actions;

export default projectSlice.reducer;
